// import React, { useEffect } from 'react';

// import useAxiosPrivate from '../../../hooks/useAxiosPrivate';

// function DonneesFacturation() {

//     const axiosPrivate = useAxiosPrivate();
//     const getMyInfos = async () => {
//         try {
//             const response = await axiosPrivate.get('/expert/getMyInfos');
//             console.log(response.data);
//             //hna khessek tdir setInfos(response.data) f xi variable diro b usestate  const [infos,setInfos] = useState({});
//         } catch (error) {
//             console.log(error);
//         }
//     };
//     useEffect(() => {
//         getMyInfos ();
//     },[]);

//     return (
//         <div>
//         Donnees Facturation
//         </div>
//     );
// }

// export default DonneesFacturation;

import './CompteClient.scss';

import { useTranslation } from 'react-i18next';

import useWindowSize from '../../../hooks/useWindowSize';
//import { useEffect } from 'react';
import DonnesFacturationParent from '../../Admin/GestionClient/DonnesFacturationParent';
import ProfilEntreprise from '../../Client/ProfileEntreprise/ProfilEntreprise';

function DonneesFacturation() {
    const { i18n } = useTranslation();
    const {device}=useWindowSize();
    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignItems: 'flex-start',alignSelf:'stretch',gap:'24px'}}>
                <div className='frame5Profile'>{i18n.t('Compte entreprise')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('Données profil')} </span> </div>
                <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',alignSelf:'stretch',gap:'24px'}}>
                    <ProfilEntreprise/>

                    <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:device=='desktop'?'80%':'100%',alignItems: 'center'}}>
                        <DonnesFacturationParent />
                    </div>
                </div>
            </div>
        </>
    );
}
export default DonneesFacturation;
